contactSearch = {};
contactSearch.search = async function (query) {
  const result = await fetch('/api/fototek/v1/contactsearch/?query='+ query, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return result.json();
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.js-contactsearch-input').focus();
  document.querySelector('.js-contactSearchSubmit').addEventListener('click', function(e) {
    document.querySelector('.js-animate-spin').classList.remove('hidden');
    document.querySelector('.js-contactSearchSubmit').disabled = true;
    setTimeout(() => {
      contactSearch.search(document.querySelector('.js-contactsearch-input').value).then((data) => {
        const results = document.querySelector('.js-results');
        var output = '';
        if (data.departments.length > 0) {
          output += data.departmentsList;
        }
        if (data.employees.length > 0) {
          output += data.employeesList;
        }
        results.innerHTML = output;
      });
      document.querySelector('.js-animate-spin').classList.add('hidden');
      document.querySelector('.js-contactSearchSubmit').disabled = false;
    }, 1000);
    e.preventDefault();
  });
}); 